import styles from 'styles/css/Main.module.scss';
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import drawerStyles from 'styles/css/Drawer.module.scss';
import actionStyles from 'styles/css/ActionStyles.module.scss';
import { handleChangeDataPageMain } from 'reduxx/actions/pages/main';
import ChatIcon from 'styles/images/svg/chat.svg';
import Logo from 'styles/images/logo/logo512.png';
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import apiRequest from 'utils/apiRequest';
import { USERS_LOGOUT_GET, WEBSITE } from 'apis';
import { actionLogOutUser } from 'reduxx/actions/pages/user/login';
import ArrowDown from 'styles/images/svg/arrow-down.svg';



const HeaderMobileEducation = (props) => {

	const dispatch = useDispatch();

	const { token } = useSelector(state => state.login);
	const { isDrawerOpen } = useSelector(state => state.main);

	const toggleDrawer = () => {
        // setIsDrawerOpen(!isDrawerOpen);
        dispatch(handleChangeDataPageMain('isDrawerOpen', !isDrawerOpen));
    };

    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const toggleAbout = () => setIsAboutOpen((prev) => !prev);

    const drawerRef = useRef(null);
    const touchStartX = useRef(null);
    const touchCurrentX = useRef(null);

    // بستن Drawer با کلیک خارج
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isDrawerOpen && drawerRef.current && !drawerRef.current.contains(event.target)) {
                // setIsDrawerOpen(false);
                dispatch(handleChangeDataPageMain('isDrawerOpen', !isDrawerOpen));
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isDrawerOpen]);

    useEffect(() => {
        if (isDrawerOpen) {
            document.body.style.overflow = "hidden"; // قفل کردن اسکرول
        } else {
            document.body.style.overflow = "auto"; // آزاد کردن اسکرول
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isDrawerOpen]);


    // مدیریت رویدادهای لمسی برای کشیدن
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
        touchCurrentX.current = touchStartX.current;
    };

    const handleTouchMove = (e) => {
        touchCurrentX.current = e.touches[0].clientX;
        const deltaX = touchCurrentX.current - touchStartX.current;
        if (deltaX > 0 && drawerRef.current) {
            drawerRef.current.style.transform = `translateX(${Math.max(0, deltaX)}px)`;
        }
    };

    const handleTouchEnd = () => {
        const deltaX = touchCurrentX.current - touchStartX.current;
        if (deltaX > 50) { // اگه بیشتر از 50px به چپ کشیده شد، Drawer بسته بشه
            // setIsDrawerOpen(false);
            dispatch(handleChangeDataPageMain('isDrawerOpen', !isDrawerOpen));
        }
        if (drawerRef.current) {
            drawerRef.current.style.transform = ''; // بازگرداندن به حالت پیش‌فرض
        }
        touchStartX.current = null;
        touchCurrentX.current = null;
    };

    const handleLogOut = () => {
        toggleDrawer();

        if(token) {
            const buttonsOkCancel = Swal.mixin({
                customClass: {
                    confirmButton: actionStyles['btn-accept'],
                    cancelButton: [actionStyles['btn-cancel'], actionStyles['mr-12']].join(' '),
                },
                buttonsStyling: false
            });

            buttonsOkCancel.fire({
                text: "آیا میخواهید از حساب کاربری خود خارج شوید؟",
                imageUrl: Logo,
                imageHeight: 80,
                imageAlt: 'دکتر20',
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: 'انصراف',
            }).then((result) => {
                if (result.isConfirmed) {
                    apiRequest({
                        dispatch,
                        endpoint: USERS_LOGOUT_GET,
                        method: 'get',
                        ...(token && { token }),
                        successMessage: 'با موفقیت از حساب کاربری خارج شدید.',
                        onSuccess: (res) => {
                            dispatch(actionLogOutUser());
                        }
                    });
                }
            }); 
        }
            
    };

    return (
    	<>

        <header className={[styles.header, styles['header--sticky']].join(' ')}>
            <div className={[sharedStyles.flex, sharedStyles.itemsCenter, sharedStyles['gapLg']].join(' ')}>
                <button className={styles['menu-btn']} aria-label="menu" onClick={toggleDrawer}>
                    <span />
                    <span />
                    <span />
                </button>
                <a href={`${WEBSITE}visit-history`}>
                    <img src={ChatIcon} height={33} style={{verticalAlign: 'middle'}} />
                </a>
            </div>
                
            <div className={styles.logo}>
                <img src={Logo} alt="دکتر20" />
            </div>
        </header>


        {isDrawerOpen && (
            <div className={drawerStyles.overlay} onClick={toggleDrawer}></div>
        )}
        <div 
                ref={drawerRef} 
                onTouchStart={handleTouchStart} 
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                className={`${drawerStyles.drawer} ${isDrawerOpen ? drawerStyles['drawer--open'] : ''}`}>
            <div className={drawerStyles.header}>
                <img src={Logo} height={60} alt="دکتر20" />

                <button className={drawerStyles['close-btn']} onClick={toggleDrawer}>
                    ✕
                </button>
            </div>
                
            <nav className={drawerStyles['drawer-nav']}>
                <ul className={sharedStyles['pb-[32px]']}>
                    <li><a href={`${WEBSITE}edit-profile`}>اطلاعات کاربری</a></li>
                    <li><a href={`${WEBSITE}about-us/activities`}>فیلدهای فعالیت Dr20</a></li>
                    <li><a href={`${WEBSITE}medical-record`}>پرونده پزشکی الکترونیک</a></li>
                    <li><a href={`${WEBSITE}visit-fee`}>نرخ ویزیت دکتربیست</a></li>
                    <li><a href={`${WEBSITE}surgury-consultation`}>درخواست مشاوره اعمال جراحی</a></li>
                    <li><a href={`${WEBSITE}vip-services`} >خدمات VIP</a></li>
                    {/*<li><a href={`${WEBSITE}discounts`}>تخفیفات ویژه Dr20</a></li>*/}
                    <li><a href={`${WEBSITE}elite-doctors-membership`}>فرم عضویت پزشکان نخبه</a></li>
                    <li><a href={`${WEBSITE}future-projects`}>پروژه‌های آینده دکتر بیست</a></li>
                    <li><a href={`${WEBSITE}investment`}>فرصت سرمایه گذاری</a></li>
                    <li><a href={`${WEBSITE}suggestions`}>پیشنهادات و نظرات</a></li>
                    <li><a href={`${WEBSITE}rules`}>قوانین و مقررات</a></li>
                    
                    <li
                        className={`${drawerStyles["menu-item-with-sub"]} ${
                          isAboutOpen ? drawerStyles["open"] : ""
                        }`}
                      >
                        <button className={drawerStyles["submenu-toggle"]} onClick={toggleAbout}>
                            درباره ما
                            <span className={drawerStyles.arrow}>
                                <img src={ArrowDown} />
                            </span>
                        </button>
                        {isAboutOpen && (
                            <ul className={drawerStyles.submenu}>
                                <li><a href={`${WEBSITE}about-us/naming-reason`}>علت نامگذاری دکتر بیست</a></li>
                                {/*<li><a href={`${WEBSITE}about-us/bylaws`}>کلیات اساس نامه</a></li>*/}
                                {/*<li><a href={`${WEBSITE}about-us/activities`}>فیلدهای فعالیت Dr20</a></li>*/}
                                <li><a href={`${WEBSITE}about-us/ceo-resume`}>رزومه مدیر‌عامل</a></li>
                            </ul>
                        )}
                    </li>
                    <li><a href={`${WEBSITE}contact-us`}>ارتباط با ما</a></li>
                    { token &&
                    <li><a onClick={handleLogOut}>خروج</a></li>
                    }
                </ul>
            </nav>
        </div>


        </>
    );
}

export default HeaderMobileEducation;
